import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { CLink } from '@coreui/react'

//component - CoreUI / CHeaderNavLink

const CHeaderNavLink = props => {

  const {
    className,
    //
    innerRef,
    ...rest
  } = props

  const classes = classNames(
    className,
    'header-nav-link'
  )

  return (
    <CLink className={classes} {...rest} ref={innerRef} />
  )

}

CHeaderNavLink.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  //
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
};

export default CHeaderNavLink